<template>
  <!-- 产品详情页面 -->
  <div class="page-container">
    <!-- 选项卡按钮 -->
    <div style="margin-bottom: 20px; text-align: left">
      <el-button
        round
        size="small"
        :class="{ changtype: changetype == 1 }"
        @click="product_detail()"
        >展品详情
      </el-button>
    </div>

    <!-- 展品详情内容 -->
    <div v-if="changetype == 1">
      <!-- 产品信息展示 -->
      <div v-if="UpdateDetailShow" class="page-card" style="margin: 20px 0">
        <div class="page-card__body" style="text-align: left; font-size: 14px; line-height: 30px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-image
                :src="img"
                style="width: 275px; height: 275px"
                fit="cover"
              ></el-image>
            </el-col>
            <el-col :span="18">
              <div style="font-weight: bold; font-size: 16px">
                {{ p_data.title }}
              </div>
              <div>分类：{{ p_data.type }}</div>
              <div style="height: 100px">
                <el-row>
                  <el-col :span="2">产品介绍:</el-col>
                  <el-col :span="21">
                    {{ p_data.info }}
                  </el-col>
                </el-row>
              </div>

              <div style="margin-top: 20px">
                <el-row>
                  <el-col :span="8">
                    发布日期：{{ p_data.create_time }}
                  </el-col>
                  <el-col :span="2">
                    <i class="el-icon-view" style="font-size: 16px"></i>
                    {{ p_data.view }}
                  </el-col>
                  <el-col :span="2">
                    <i class="el-icon-view" style="font-size: 16px"></i>
                    {{ p_data.praise }}
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <el-button size="small" @click="updateProduct"
                      >修改产品信息</el-button
                    >
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 产品信息编辑表单 -->
      <div v-else class="page-card" style="margin: 20px 0">
        <div class="page-card__body">
          <el-form
            :model="productForm"
            label-width="120px"
            :rules="rules"
            ref="productForm"
          >
            <el-row
              :gutter="20"
              style="
                text-align: left;
                font-size: 14px;
                line-height: 30px;
              "
            >
              <el-col :span="6">
                <el-form-item prop="img" label-width="0px">
                  <el-image :src="updateImg"></el-image>
                  <el-upload
                    class="avatar-uploader"
                    :action="imagesrc"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :headers="headers"
                    :before-upload="beforeAvatarUpload"
                  >
                    <el-button size="small" type="primary" round
                      >点击上传</el-button
                    >
                    <div slot="tip" class="el-upload__tip">
                      最佳展示尺寸：1:1，建议500 x 500像素以上
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>

              <el-col :span="18">
                <el-form-item prop="title" label="产品名称：">
                  <el-input
                    placeholder="请填写产品名称"
                    v-model="productForm.title"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="type" label="产品分类：">
                  <el-radio-group v-model="productForm.type">
                    <el-radio label="紧固件"></el-radio>
                    <el-radio label="设备"></el-radio>
                    <el-radio label="模具"></el-radio>
                    <el-radio label="表面处理"></el-radio>
                    <el-radio label="原材料"></el-radio>
                    <el-radio label="检测"></el-radio>
                    <el-radio label="其他"></el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item prop="info" label="产品介绍：">
                  <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请填写产品介绍"
                    v-model="productForm.info"
                  ></el-input>
                </el-form-item>

                <el-row style="margin: 20px; text-align: center">
                  <el-button type="primary" round @click="p_onsubmit('productForm')"
                    >确定发布</el-button
                  >

                  <el-button round @click="updateProduct">取消修改</el-button>
                </el-row>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 同展商展品列表 -->
    <div v-else-if="changetype == 2">
      <div class="page-card" style="max-width: 1200px; width: 100%; min-height: 1000px; margin: 0 auto">
        <!-- 页面头部 -->
        <div class="page-card__header">
          <span style="font-weight: bold">{{ userInfo.name }}</span>
        </div>
        <div class="page-card__header">
          <span style="font-weight: bold">参展展品</span>
        </div>
        <!-- 数据表格 -->
        <div class="page-card__body">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="img" label="产品图" width="80">
              <template slot-scope="scope">
                <el-image :src="imgUrl + scope.row.img"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="公司名称"> </el-table-column>

            <el-table-column prop="type" label="产品分类"> </el-table-column>
            <el-table-column prop="view" label="浏览数" width="80">
            </el-table-column>
            <el-table-column prop="praise" label="点赞数" width="80">
            </el-table-column>
            <el-table-column prop="share" label="转发数" width="80">
            </el-table-column>

            <el-table-column prop="create_time" label="加入日期">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="handleClick(scope.row)"
                >查看详情</el-button>
                <el-button type="text">备注</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页区域 -->
        <div style="margin: 20px 0; padding: 20px 0">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pagesize"
            :total="aSum"
            :page-count="pageCount"
            :current-page.sync="currentPage"
            background
            layout="prev, pager, next,jumper"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "",
  data() {
    return {
      p_data: [],
      type: [],
      userInfo: [],
      p_id: "",
      userid: "",
      changetype: 1,
      UpdateDetailShow: true,
      headers: { Authorization: "JWT " + localStorage.getItem("adminToken") },
      imagesrc: this.baseUrl + "/admin/uploadfile/product/",
      imgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/product/",
      img: "",
      updateImg: "",
      tableData: [],
      productForm: {
        title: "",
        info: "",
        type: '',
        img: "",
      },
      rules: {
        img: [{ required: true, message: "请输入产品图", trigger: "blur" }],

        title: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
        type: [{ required: true, message: "请输入产品分类", trigger: "blur" }],
        info: [{ required: true, message: "请输入产品介绍", trigger: "blur" }],
      },

      // 分页相关数据
      aSum: 0,
      currentPage: 1,
      pageCount: 1,
      pagesize: 10,
    };
  },
  mounted() {
    // 初始化加载产品详情、列表和用户信息
    this.p_id = this.$route.query.id;
    this.userid = this.$route.query.user;
    this.detailData();
    this.listData();
    this.userData();
  },
  methods: {
    // 获取用户信息
    userData() {
      let userid = this.userid;
      let url = this.baseUrl + "/admin/users/" + userid + "/";
      api.fetchData(url).then((res) => {
        this.userInfo = res;
      });
    },

    // 提交产品修改表单
    p_onsubmit(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let id = this.p_id;
          let url = this.baseUrl + "/admin/products/" + id + "/";
          api
            .patchData(url, {
              title: this.productForm.title,
              info: this.productForm.info,
              type: this.productForm.type,
              img: this.productForm.img,
            })
            .then((res) => {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.detailData();
              this.updateProduct();
            });
        }
      });
    },

    // 获取产品详情数据
    detailData() {
      let id = this.p_id;
      let url = this.baseUrl + "/admin/products/" + id + "/";
      api.fetchData(url).then((res) => {
        this.p_data = res;
        this.img = this.imgUrl + this.p_data.img;
        this.productForm = res;
        this.updateImg = this.imgUrl + this.productForm.img;
      });
    },

    // 获取产品列表数据
    listData() {
      let userid = this.userid;
      let url = this.baseUrl + "/admin/products/?user=" + userid;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 分页切换处理
    handleCurrentChange(val) {
      let userid = this.userid;
      let url =
        this.baseUrl + "/admin/products/?user=" + userid + "&page=" + val;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;

        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    // 图片上传成功回调
    handleAvatarSuccess(res, file) {
      let imageUrl = URL.createObjectURL(file.raw);
      this.productForm.img = res.filename;
      this.updateImg = this.imgUrl + this.productForm.img;
    },

    // 图片上传前校验
    beforeAvatarUpload(file) {
    },

    // 切换到产品详情视图
    product_detail() {
      this.changetype = 1;
    },

    // 切换到同展商展品视图
    equally_product() {
      this.changetype = 2;
    },

    // 切换产品信息展示/编辑状态
    updateProduct() {
      if (this.UpdateDetailShow === true) {
        this.UpdateDetailShow = false;
      } else {
        this.UpdateDetailShow = true;
      }
    },

    // 跳转到产品详情页
    handleClick(row) {
      this.$router.push({
        name: "admin_productDetail",
        query: { id: row.id, user: row.user },
      });
    },
  },
};
</script>

<style scoped>
.index-block {

  margin: 0 auto;
  min-height: 1000px;
}

.changtype {
  background-color: var(--color-primary);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/productDetail.vue